import { render, staticRenderFns } from "./RootContrattiIdView.vue?vue&type=template&id=51fc3051&"
import script from "./RootContrattiIdView.vue?vue&type=script&lang=ts&"
export * from "./RootContrattiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports